const ReviewSlides = [
  {
    id: 1,
    name: "William H",
    position: "Owner",
    company: "Pharmhill",
    description:
      "What I loved most about Revv is the template library. It saved me so much time on research and writing from scratch. Revv also enabled speedy communication and allowed me to be more productive with the saved time. It is the right fit for my small startup",
    star: 5,
    // link: "https://www.g2.com/products/revv-revv/reviews/revv-review-4590989",
  },
  {
    id: 2,
    name: "Eric Yohay",
    position: "CEO",
    company: "Salesflow, Inc.",
    description:
      "It is a great product that allows you to send proposals with quotes embedded in it. This solves the problem of customer having to download an attachment to view their options. And Revv's support is awesome!",
    star: 4.5,
    // link: "https://www.g2.com/products/revv-revv/reviews/revv-review-4533527",
  },
  {
    id: 3,
    name: "Raphael Robertson",
    position: "Chief Marketing Officer",
    company: "Robetson marketing and branding",
    description:
      "What I like best about Revv - Where do I start? It is very easy to navigate. They offer most of the templates you need which can be customized easily. Using the software is very easy and less time-consuming. And lastly, the support is so so so good and easy to avail.",
    star: 4.5,
    // link: "https://www.g2.com/products/revv-revv/reviews/revv-review-4514223",
  },
];

export default ReviewSlides;
